module.exports = __webpack_public_path__ + "img/prueba1.1f217f6e.png";